import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {Payday} from "../../Payday";
import {gsap} from "gsap";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";

/**
 * Created by jonas on 2022-09-02.
 */

export class FreespinsRetrigger implements SimplePresentation {

    name:string = "FreespinsRetrigger";

    constructor() {

    }

    public shouldRun():boolean {
        const mode = Payday.model.data.mode;
        const nextMode = Payday.model.data.nextMode;
        return !Payday.model.isRestore &&
               !Payday.model.gameData.brokeTheBank &&
               Payday.model.scatterIndices().length > 0 &&
               mode == GameMode.FREESPIN && nextMode == GameMode.FREESPIN;
    }

    public start(controller:SimplePresentationRunnerController):void {
        const tl = gsap.timeline();
        Payday.autoPlayPlugin.turnOffAutoplayOnBonus();
        tl.add(() => {
            controller.setSkipCallback(() => {
                tl.progress(1, false)
            });
        });

        if (Payday.apiPlugin.settings.get(APISetting.FAST_SPIN))
            tl.timeScale(1.55);

        const scatters = Payday.model.scatterIndices();
        const scatterCount = scatters.length * 3;
        tl.add(() => {
            Payday.soundPlayer.playSound("bonusClawSpins");
        })
        tl.add(Payday.reelView.getSymbolsAt(scatters).map((scatter) => scatter.getWinAnimation()), '<');
        tl.add(() => {
            Payday.soundPlayer.playSound("bonusNumberDisplay");
        }, '>0.33')
        tl.add(Payday.transitionScreen.showFreespinsRetrigger(scatterCount), '<');
        tl.add(() => {
            Payday.keypadPlugin.setZeroBetSpinCounter(Payday.model.data.freespinsLeft)
        })

        tl.add(() => {
            controller.finish();
            controller.setSkipCallback();
        },'>0.65');

    }
}